export class Attribute {

  Editable: boolean;
  Customizable: boolean;
  DisplayOrder: number;
  DisplayScopeDID: string;
  Enabled: boolean;
  Nullable: boolean;
  Required: boolean;
  Visible: boolean;
  IsNew: boolean;
  Active: boolean;
  Searchable: boolean;
  Publish: boolean;
  WaitToLoad: boolean;
  Min: any;
  Max: any;
  Mask: MaskAttributes;

  ActivePage: number;
  RowsPerPage: number;
  SortOrder: string;
  DisplayFormat: any;
  RowCount: number;
  PageCount: number;
  SortColumn: string;
  DisplayLimit: number;
  IsRowSelected: boolean;
  InitSort: { SortBy: string; SortOrder: string; CosyDataTypeDID: any };

  OnInitUAID: string;
  OnPagerUAID: string;
  OnSelectUAID: string;
  OnUnSelectUAID: string;
  OnMultiSelectUAID: string;
  OnChangeUAID: string;
  OnDetailUAID: string;
  OnSortUAID: string;
  OnClickUAID: string;
  OnDblClickUAID: string;
  OnNodeDragUAID: string;
  OnColSelectUAID: string;

  ValidUAID: string;
  InvalidUAID: string;
  FormControllerMatrixID: string;
  AssignedColumnWidth: any;

  ActivateOnIE: string;
  Filter: string;

  FileName: string;
  DisplayFileName: string;
  MimeType: string;

  GroupID: string;
  TreeGroupID: string;
  TreeID: string;
  ParentID: string;
  OrderNo: number;

  CustomStyle: CustomStyle;
  HyperLink: string;


  /*Design Attributes */
  Width: number;
  Height: number;
  Alignment : string;
}

export class CustomStyle {
  BackGroundColor: string;
  Color: string;
  Height: string;
  Width: string;
  Border: string;
}

export class MaskAttributes {
  Pattern: string;
  Value: string;
}
